var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#555",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.447 6.549c-.273.06-.586.223-.79.412-.251.232-5.063 5.737-5.133 5.872-.118.226.007.495.293.634.185.089.324.072.473-.059.057-.05 1.214-1.361 2.571-2.912 2.203-2.519 2.485-2.83 2.643-2.908a.756.756 0 0 1 .843.103c.061.051 1.164 1.217 2.453 2.592 2.796 2.985 2.949 3.142 3.092 3.182.163.045.316-.013.469-.179.167-.182.203-.331.117-.495-.081-.155-5.369-5.788-5.577-5.94a1.78 1.78 0 0 0-1.454-.302",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.cbc0de43d23cd4c610f007ec36ec0aaf.svg";
export { ForwardRef as ReactComponent };